$(document).ready(function(){
  $('.inner-image-with-text-wrapper').on('click', function() {
        //variable to handle 
        let handle = $(this).data('handle');
        let url = $(this).data('url');

        //Active Class/ remove 
        $('.inner-image-with-text-wrapper').removeClass('active');
        $(this).addClass('active');
         $(".error-message" ).remove();
        //Next Step btn 
        $('.next_step_btn').attr('href', url).attr('data-handle', handle);
    });
    var count = false;
  $('.button-wrapper-jtpl .next_step_btn').on('click', function() {
    $('.inner-image-with-text-wrapper').each(function(){
      if($('.inner-image-with-text-wrapper').hasClass("active")){
        $(".error-message" ).remove();
      }else{
        if(count == false){
          $(".button-wrapper-jtpl" ).append( '<span class="error-message"> Please make a selection first</span>' );
          count = true;
        }
        
      }
    });
   });
  });